import type { SceneObjectValidationIssue } from "../modeling/sceneObjectValidation.ts";
import type { SceneObject } from "../modeling/types.ts";
import { showToast } from "../ui/toastBus.ts";

const reportedInvalidObjects = new Set<string>();

export function reportInvalidSceneObject(
  obj: SceneObject,
  validation: SceneObjectValidationIssue,
): void {
  const key = `${obj.id}:${validation.reason}`;
  if (reportedInvalidObjects.has(key)) return;
  reportedInvalidObjects.add(key);
  showToast(`Skipped invalid object "${obj.name}".`, {
    severity: "warning",
    duration: 7000,
    dedupKey: `invalid-scene-object:${obj.id}`,
  });
  console.warn("[scene-object] skipped invalid object", {
    id: obj.id,
    name: obj.name,
    reason: validation.reason,
  });
}
